import background from 'assets/img/1.jpg'
import logoNuevo from 'assets/img/favicon.png'
import { useUser } from 'contexts/UserContext'
import LoginForm from 'forms/login/loginForm'
import useFetch from 'hooks/useFetch'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'

export default function Login() {
  const { setUser } = useUser()
  const [, setLocation] = useLocation()
  const [requestedLogin, requestLogin] = useFetch()
  const [loginError, setLoginError] = useState(null)

  const handleSubmitLogin = async (values) => {
    await requestLogin({
      url: 'auth/login',
      method: 'POST',
      body: values,
      messageKo: 'Usuario y/o contraseña incorrectos'
    })
  }

  useEffect(() => {
    if (requestedLogin.data) {
      setLoginError(null)
      setUser(requestedLogin.data)
      setLocation('/')
    }
  }, [requestedLogin.data, setUser, setLocation])

  useEffect(() => {
    if (requestedLogin.isCalled && requestedLogin.error) {
      setLoginError('¡Usuario o contraseña incorrectos!')
    }
  }, [requestedLogin.isCalled, requestedLogin.error])

  return (
    <div className="bg-white">
      <div className="flex justify-center h-screen">
        {/* Fondo imagen (solo imagen, sin overlay ni logos) */}
        <div
          className="hidden lg:block lg:w-2/3 bg-cover bg-center"
          style={{
            backgroundImage: `url(${background})`
          }}
        />

        {/* Panel login */}
        <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-2/6">
          <div className="flex-1">
            <div className="text-center">
              <div className="flex justify-center mx-auto">
                <img
                  className="w-auto h-28"
                  src={logoNuevo}
                  alt="Bresco"
                />
              </div>

              <p className="mt-3 text-gray-500">
                Inicie sesión para acceder a su cuenta.
              </p>
            </div>

            <div className="mt-8">
              <LoginForm
                loginError={loginError}
                handleSubmit={handleSubmitLogin}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
